/**
 *
 * @param x
 * @return {string}
 */
export function firstLetterUpper(x) {
  if (!x) {
    return x;
  }
  if (`${x}`.length < 2) {
    return `${x}`.toUpperCase();
  }
  const b = `${x}`.trim().split(" ").map(y => {
    return `${y}`.substring(0, 1).toUpperCase() + `${y}`.substring(1);
  }).join(" ");
  return b; // `${x}`.substring(0, 1).toUpperCase() + `${x}`.substring(1);
}